import { supabase } from '@/integrations/supabase/client';

/**
 * Create new product
 */
export async function createProduct(productData: {
  slug: string;
  title: string;
  subtitle?: string;
  description?: string;
  price?: number;
  categories?: string[];
  service_type?: string;
  is_published?: boolean;
  created_by?: string;
}) {
  const { data, error } = await supabase
    .from('products')
    .insert({
      slug: productData.slug,
      title: productData.title,
      subtitle: productData.subtitle || null,
      description: productData.description || null,
      price: productData.price || null,
      categories: productData.categories || [],
      service_type: productData.service_type || null,
      is_published: productData.is_published || false,
      created_by: productData.created_by || null,
    })
    .select()
    .single();

  if (error) throw error;
  return data;
}

/**
 * Get product by slug for enrichment
 */
export async function getProductBySlug(slug: string) {
  const { data, error } = await supabase
    .from('products')
    .select('*')
    .eq('slug', slug)
    .maybeSingle();

  if (error) throw error;
  return data;
}
